// Adapted from: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tab_role

export default class Tablist {

    constructor(userOptions = {}) {
        const defaultOptions = {}

        this.options = Object.assign(defaultOptions, userOptions);

        window.addEventListener('DOMContentLoaded', () => {
            this.onLoad();
        });
    }

    onLoad() {
        const tabs = document.querySelectorAll('[role="tab"]');
        const tabList = document.querySelector('[role="tablist"]');

        // Add a click event handler to each tab
        tabs.forEach(tab => {
            if (tab !== null) {
                tab.addEventListener('click', this.changeTabs);
            }
        });

        // Enable arrow navigation between tabs in the tab list
        let tabFocus = 0;

        if (tabList !== null) {
            tabList.addEventListener('keydown', e => {
                // Move right
                if (e.keyCode === 39 || e.keyCode === 37) {
                    tabs[tabFocus].setAttribute('tabindex', -1);
                    if (e.keyCode === 39) {
                        tabFocus++;
                        // If we're at the end, go to the start
                        if (tabFocus >= tabs.length) {
                            tabFocus = 0;
                        }
                        // Move left
                    } else if (e.keyCode === 37) {
                        tabFocus--;
                        // If we're at the start, move to the end
                        if (tabFocus < 0) {
                            tabFocus = tabs.length - 1;
                        }
                    }

                    tabs[tabFocus].setAttribute('tabindex', 0);
                    tabs[tabFocus].focus();
                }
            });
        }
    }

    changeTabs(e) {
        const target = e.target;
        const parent = target.parentNode;
        const grandparent = parent.parentNode;

        // Remove all current selected tabs
        parent
            .querySelectorAll('[aria-selected="true"]')
            .forEach(t => t.setAttribute('aria-selected', false));

        // Set this tab as selected
        target.setAttribute('aria-selected', true);

        // Hide all tab panels
        grandparent
            .querySelectorAll('[role="tabpanel"]')
            .forEach(p => p.setAttribute('hidden', true));

        // Show the selected panel
        grandparent.parentNode
            .querySelector(`#${target.getAttribute('aria-controls')}`)
            .removeAttribute('hidden');
    }
}